module.exports = __webpack_public_path__ + "img/business_22.657cfeb0.jpg";